(function () {
  const STORAGE_KEY = 'hb:breadcrumb-trail';

  function getPathname(url) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch {
      return '';
    }
  }

  function parseJson(el) {
    if (!el) return [];
    try {
      const data = JSON.parse(el.textContent);
      return Array.isArray(data) ? data : [];
    } catch {
      return [];
    }
  }

  function shouldUseStoredTrail(trail) {
    if (!trail.length) return false;

    const referrer = document.referrer;
    if (!referrer) return false;

    const refPath = getPathname(referrer);
    return trail.some((item) => getPathname(item.url) === refPath);
  }

  function isCollectionProductUrl() {
    return /\/collections\/[^/]+\/products\//.test(window.location.pathname);
  }

  function createBreadcrumbItem(title, url) {
    const li = document.createElement('li');
    li.className = 'breadcrumbs__item';
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.textContent = title;
    li.appendChild(anchor);
    return li;
  }

  function saveCollectionTrail() {
    const dataEl = document.getElementById('collection-breadcrumb-data');
    if (!dataEl) return;
    sessionStorage.setItem(STORAGE_KEY, dataEl.textContent);
  }

  function initProductBreadcrumbs(nav) {
    const list = nav.querySelector('.breadcrumbs__list');
    const productItem = list?.querySelector('[data-product-breadcrumb]');
    if (!list || !productItem) return;

    let trail = [];

    if (isCollectionProductUrl()) {
      trail = parseJson(document.getElementById('product-breadcrumb-fallback'));
    } else {
      const storedTrail = parseJson({ textContent: sessionStorage.getItem(STORAGE_KEY) || '[]' });
      if (shouldUseStoredTrail(storedTrail)) {
        trail = storedTrail;
      } else {
        trail = parseJson(document.getElementById('product-breadcrumb-fallback'));
      }
    }

    trail.forEach((item) => {
      if (!item?.title || !item?.url) return;
      list.insertBefore(createBreadcrumbItem(item.title, item.url), productItem);
    });
  }

  function init() {
    const nav = document.querySelector('[data-breadcrumbs-nav]');
    if (!nav) return;

    const pageType = nav.dataset.pageType;

    if (pageType === 'collection') {
      saveCollectionTrail();

      document.addEventListener(
        'click',
        (event) => {
          const link = event.target.closest('a[href*="/products/"]');
          if (!link) return;
          saveCollectionTrail();
        },
        true
      );
    }

    if (pageType === 'product') {
      initProductBreadcrumbs(nav);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();